import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';

import { FilterField } from 'src/app/shared/interfaces';
import { FilterModalComponent } from './filter-modal.component';

@Injectable()
export class FilterModalService {
  constructor(
    private modalService: BsModalService
  ) { }

  public show(fields: FilterField[]): Promise<Params> {
    return new Promise((resolve, reject) => {
      const modal = this.modalService.show(FilterModalComponent, { class: 'modal-md', ignoreBackdropClick: true });
      modal.content.setOption(resolve, fields);
    });
  }
}
